module.exports = __webpack_public_path__ + "static/Data-Selection-5c887ac669a33100f95aa5b94f1d1b44.png";